import { useEffect, useCallback } from 'react';
import { useChartContext } from '../components/chart.context';

export const useChartResize = () => {
  const {
    chartContainerRef,
    chartRef,
    indicatorContainerRefs,
    indicatorChartRefs,
    chartInitialized,
    data: { indicatorConfigs }
  } = useChartContext();

  const handleResize = useCallback(() => {
    if (!chartInitialized) return;

    // Resize the main chart
    chartRef.current?.applyOptions({
      width: chartContainerRef.current?.clientWidth,
      height: chartContainerRef.current?.clientHeight
    });

    indicatorConfigs.subplot.forEach(({ type }) => {
      indicatorChartRefs.current[type]?.forEach((chart) =>
        chart.applyOptions({
          width: indicatorContainerRefs.current?.[type].clientWidth,
          height: indicatorContainerRefs.current?.[type].clientHeight
        })
      );
    });
  }, [
    chartInitialized,
    indicatorConfigs.subplot,
    indicatorChartRefs,
    indicatorContainerRefs,
    chartRef,
    chartContainerRef
  ]);

  useEffect(() => {
    const chartContainer = chartContainerRef.current;
    if (!chartContainer) return;

    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });

    resizeObserver.observe(chartContainer);

    const indicatorContainers = indicatorContainerRefs.current;
    if (indicatorContainers) {
      Object.values(indicatorContainers).forEach((container) => {
        if (container) resizeObserver.observe(container);
      });
    }

    // Initial resize when chart becomes ready
    handleResize();

    const onWindowResize = () => handleResize();
    window.addEventListener('resize', onWindowResize);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', onWindowResize);
    };
  }, [handleResize, chartInitialized]);
};
